import { Badge } from '@/components/ui/badge';
import { cn, formatCurrency } from '@/lib/utils';

type CartItemPriceProps = {
  effective: number;
  original: number;
  hasPromotion: boolean;
  discountPercent: number | null;
  locale: string;
  alignEnd?: boolean;
};

export function CartItemPrice({
  effective,
  original,
  hasPromotion,
  discountPercent,
  locale,
  alignEnd = false,
}: CartItemPriceProps) {
  if (hasPromotion) {
    return (
      <div className={alignEnd ? 'text-right' : undefined}>
        <p className="text-base font-semibold text-green-600">
          {formatCurrency(effective, locale)}
        </p>
        <div className={cn('flex items-center gap-1.5', alignEnd && 'justify-end')}>
          <p className="text-xs text-muted-foreground line-through">
            {formatCurrency(original, locale)}
          </p>
          {discountPercent !== null && discountPercent > 0 && (
            <Badge className="h-4 border-transparent bg-green-600 px-1 py-0 text-[9px] leading-none text-white hover:bg-green-600">
              -{discountPercent}%
            </Badge>
          )}
        </div>
      </div>
    );
  }

  return (
    <p className={cn('text-base font-semibold text-foreground', alignEnd && 'text-right')}>
      {formatCurrency(effective, locale)}
    </p>
  );
}
